import { CoreEnums } from '@/utils/domain/constants';

export const MODEL_NAME = 'whiteLabel';

export const ROUTES = {
  LOCAL: 'company/white-label',
  EFFECTIVE: 'company/white-label/effective',
  CUSTOM_DOMAIN: 'company/white-label/custom-domain',
  CUSTOM_DOMAIN_VERIFY: 'company/white-label/custom-domain/verify',
  CUSTOM_DOMAIN_ACTIVATE: 'company/white-label/custom-domain/activate',
  CUSTOM_DOMAIN_DISABLE: 'company/white-label/custom-domain/disable',
};

export const WhiteLabelSource = CoreEnums.WhiteLabelSource;
export const WhiteLabelCustomDomainStatus = CoreEnums.WhiteLabelCustomDomainStatus;

export const MAIN_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const BRANDING_MEDIA_FIELDS = [
  'logoMediaId',
  'iconLogoMediaId',
  'faviconMediaId',
  'fontMediaId',
  'loginSplashMediaId',
];

export const BRANDING_FORM_FIELDS = [
  'isActive',
  'applyToChildren',
  'brandName',
  'mainColor',
  ...BRANDING_MEDIA_FIELDS,
  'supportEmail',
];
